'use client';

import { ComponentPropsWithoutRef, useLayoutEffect } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import { useModalContext } from './modal-context';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const ModalDescription = ({ children, className, ...props }: Props) => {
    const { modalId } = useModalContext();

    useLayoutEffect(() => {
        document
            .getElementById(`modal-${modalId}-wrapper`)
            ?.setAttribute('aria-describedby', `modal-${modalId}-description`);

        return () => {
            document.getElementById(`modal-${modalId}-wrapper`)?.removeAttribute('aria-describedby');
        };
    }, []);

    return (
        <Layout element="p" id={`modal-${modalId}-description`} className={cn(className)} {...props}>
            {children}
        </Layout>
    );
};
